<template>
	<div class="trade-log">
		<div class="trade-log__head">
			<span class="trade-log__title">
				最近结算日志
				<span v-if="log.length" class="trade-log__count">{{ log.length }}</span>
			</span>
			<button v-if="log.length > previewCount" class="trade-log__more" @click="expanded = true">
				查看更多
			</button>
		</div>
		<div class="trade-log__list">
			<div v-if="log.length === 0" class="trade-log__empty">暂无记录</div>
			<div v-for="(entry, index) in previewLog" :key="index" class="trade-log__item" :class="'is-' + entry.type">
				<span class="trade-log__time">{{ entry.time }}</span>
				<span class="trade-log__text">{{ entry.text }}</span>
				<span v-if="entry.amount != null" class="trade-log__amount">{{ fmtSignedMoney(entry.amount) }}</span>
			</div>
		</div>

		<div v-if="expanded" class="trade-log__modal" @click.self="expanded = false">
			<div class="trade-log__modal-card">
				<div class="trade-log__modal-head">
					<span class="trade-log__modal-title">全部结算日志（{{ log.length }} 条）</span>
					<button class="trade-log__modal-close" @click="expanded = false">关闭</button>
				</div>
				<div class="trade-log__modal-list">
					<div v-if="log.length === 0" class="trade-log__empty">暂无记录</div>
					<div v-for="(entry, index) in log" :key="index" class="trade-log__item" :class="'is-' + entry.type">
						<span class="trade-log__time">{{ entry.time }}</span>
						<span class="trade-log__text">{{ entry.text }}</span>
						<span v-if="entry.amount != null" class="trade-log__amount">{{ fmtSignedMoney(entry.amount) }}</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { fmtSignedMoney } from '@/util/fx/format'

/**
 * 预览日志条数
 */
const PREVIEW_COUNT = 4

export default {
	name: 'TradeLogPanel',
	props: {
		log: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {
			expanded: false,
			previewCount: PREVIEW_COUNT
		}
	},
	computed: {
		/**
		 * 预览日志（最新若干条）
		 */
		previewLog() {
			return this.log.slice(0, PREVIEW_COUNT)
		}
	},
	methods: {
		fmtSignedMoney
	}
}
</script>

<style scoped>
.trade-log {
	height: 100%;
	box-sizing: border-box;
	background: linear-gradient(180deg, var(--fx-panel-2), var(--fx-panel));
	border: 1px solid var(--fx-border);
	border-radius: 12px;
	padding: 14px;
	min-height: 0;
	display: flex;
	flex-direction: column;
}

.trade-log__head {
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 10px;
}

.trade-log__title {
	display: inline-flex;
	align-items: center;
	gap: 8px;
	font-size: 13px;
	font-weight: 600;
	color: var(--fx-text);
	letter-spacing: 0.04em;
}

.trade-log__count {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	min-width: 18px;
	height: 18px;
	padding: 0 5px;
	border-radius: 999px;
	background: var(--fx-accent-soft);
	border: 1px solid rgba(77, 162, 255, 0.4);
	color: #9cc7ff;
	font-size: 12px;
	font-weight: 700;
	font-family: var(--fx-mono);
	box-sizing: border-box;
}

.trade-log__more {
	padding: 2px 10px;
	border-radius: 999px;
	border: 1px solid rgba(77, 162, 255, 0.4);
	background: var(--fx-accent-soft);
	color: #9cc7ff;
	font-size: 12px;
	cursor: pointer;
	transition: background 0.15s, border-color 0.15s;
}

.trade-log__more:hover {
	background: rgba(77, 162, 255, 0.26);
	border-color: rgba(77, 162, 255, 0.7);
}

.trade-log__list {
	flex: 1;
	overflow-y: auto;
	display: flex;
	flex-direction: column;
	gap: 5px;
}

.trade-log__empty {
	font-size: 14px;
	color: var(--fx-text-dim);
	text-align: center;
	padding: 20px 0;
}

.trade-log__item {
	display: flex;
	align-items: center;
	gap: 8px;
	font-size: 13px;
	padding: 6px 9px;
	border-radius: 6px;
	background: rgba(255, 255, 255, 0.03);
	transition: background 0.15s;
}

.trade-log__item:hover {
	background: rgba(255, 255, 255, 0.06);
}

.trade-log__item::before {
	content: '';
	width: 5px;
	height: 5px;
	border-radius: 50%;
	background: var(--fx-text-faint);
	flex-shrink: 0;
}

.trade-log__time {
	color: var(--fx-text-faint);
	font-family: var(--fx-mono);
	font-size: 12px;
	flex-shrink: 0;
}

.trade-log__text {
	color: var(--fx-text-dim);
	flex: 1;
	min-width: 0;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.trade-log__amount {
	font-family: var(--fx-mono);
	font-variant-numeric: tabular-nums;
	font-weight: 600;
	flex-shrink: 0;
}

.trade-log__item.is-open::before,
.trade-log__item.is-liquidate::before {
	background: var(--fx-up);
}

.trade-log__item.is-close::before,
.trade-log__item.is-repay::before {
	background: var(--fx-down);
}

.trade-log__item.is-interest::before {
	background: var(--fx-warn);
}

.trade-log__item.is-borrow::before {
	background: var(--fx-accent);
}

.trade-log__item.is-liquidate::before,
.trade-log__item.is-gameover::before {
	box-shadow: 0 0 6px var(--fx-up);
}

.trade-log__item.is-open .trade-log__amount,
.trade-log__item.is-liquidate .trade-log__amount {
	color: var(--fx-up);
}

.trade-log__item.is-close .trade-log__amount,
.trade-log__item.is-repay .trade-log__amount {
	color: #43d9a0;
}

.trade-log__item.is-interest .trade-log__amount {
	color: var(--fx-warn);
}

.trade-log__item.is-borrow .trade-log__amount {
	color: #9cc7ff;
}

.trade-log__item.is-gameover .trade-log__text {
	color: #ff8d84;
	font-weight: 700;
}

.trade-log__modal {
	position: fixed;
	inset: 0;
	z-index: 40;
	background: rgba(3, 5, 10, 0.62);
	backdrop-filter: blur(6px);
	display: flex;
	align-items: center;
	justify-content: center;
	animation: trade-log-fade-in 0.2s ease-out;
}

.trade-log__modal-card {
	width: 520px;
	max-width: 92vw;
	max-height: 72vh;
	display: flex;
	flex-direction: column;
	background: linear-gradient(180deg, var(--fx-panel-2), var(--fx-panel));
	border: 1px solid var(--fx-border-strong);
	border-radius: 14px;
	padding: 16px;
	box-shadow: 0 28px 90px rgba(0, 0, 0, 0.55);
	animation: trade-log-card-in 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}

.trade-log__modal-head {
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 12px;
}

.trade-log__modal-title {
	font-size: 14px;
	font-weight: 600;
	color: var(--fx-text);
}

.trade-log__modal-close {
	padding: 4px 12px;
	border-radius: 7px;
	border: 1px solid var(--fx-border);
	background: rgba(255, 255, 255, 0.04);
	color: var(--fx-text-dim);
	font-size: 13px;
	cursor: pointer;
	transition: border-color 0.15s, color 0.15s;
}

.trade-log__modal-close:hover {
	border-color: var(--fx-border-strong);
	color: var(--fx-text);
}

.trade-log__modal-list {
	flex: 1;
	overflow-y: auto;
	display: flex;
	flex-direction: column;
	gap: 5px;
}

.trade-log__modal-list::-webkit-scrollbar,
.trade-log__list::-webkit-scrollbar {
	width: 8px;
}

.trade-log__modal-list::-webkit-scrollbar-thumb,
.trade-log__list::-webkit-scrollbar-thumb {
	background: rgba(148, 170, 220, 0.16);
	border-radius: 999px;
}

.trade-log__modal-list::-webkit-scrollbar-thumb:hover,
.trade-log__list::-webkit-scrollbar-thumb:hover {
	background: rgba(148, 170, 220, 0.28);
}

@keyframes trade-log-fade-in {

	from {
		opacity: 0;
	}

	to {
		opacity: 1;
	}
}

@keyframes trade-log-card-in {

	from {
		opacity: 0;
		transform: translateY(10px) scale(0.98);
	}

	to {
		opacity: 1;
		transform: translateY(0) scale(1);
	}
}

@media (prefers-reduced-motion: reduce) {

	.trade-log__modal,
	.trade-log__modal-card {
		animation: none;
	}
}
</style>
